module.exports = __webpack_public_path__ + "static/img/rank_84.57360fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_84.png
// module id = Z6nj
// module chunks = 0